document.addEventListener("DOMContentLoaded", function () {

  const img1 = document.querySelector(".image-block--AWU5pejFWOGZVUGtRe__image_h9yzcP");
  const img2 = document.querySelector(".image-block--AREtZb0NWR0dKNk1FS__image_T9JYiL");

  if (!img1 || !img2) return;

  window.addEventListener("scroll", function () {

    const rect = img1.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    if (rect.top < windowHeight && rect.bottom > 0) {

      let move = (windowHeight - rect.top) * 0.02; // speed control

      // Opposite direction movement
      img1.style.transform = `translateX(${move}px)`;
      img2.style.transform = `translateX(-${move}px)`;

    }

  });

});



window.addEventListener("scroll", () => {
  const images = document.querySelectorAll(".slide__image");

  images.forEach((image) => {
    const rect = image.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    if (rect.top < windowHeight && rect.bottom > 0) {
      let progress = (windowHeight - rect.top) / (windowHeight + rect.height);
      let scale = 1 + progress * 0.2;
      image.style.transform = `scale(${scale})`;
    }
  });
});




window.addEventListener("scroll", () => {
  const images = document.querySelectorAll(".image-block--AUjIvN0lyTWJJNjBsT__image_nqk4Ra");

  images.forEach((image) => {
    const rect = image.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    if (rect.top < windowHeight && rect.bottom > 0) {
      let progress = (windowHeight - rect.top) / (windowHeight + rect.height);
      let scale = 0.8 + progress * 0.2;
      image.style.transform = `scale(${scale})`;
    }
  });
});



document.addEventListener("DOMContentLoaded", function () {

  const img1 = document.querySelector(".image-block--AV2tsQWNxd2drVlBLW__image_7TUf78");
  const img2 = document.querySelector(".image-block--AVzZLTnl6QmtuR3NCc__image_G4bzTd");

  if (!img1 || !img2) return;

  window.addEventListener("scroll", function () {

    const rect = img1.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    if (rect.top < windowHeight && rect.bottom > 0) {

      let move = (windowHeight - rect.top) * 0.02; // speed control

      // Opposite direction movement
      img1.style.transform = `translateY(${move}px)`;
      img2.style.transform = `Y(-${move}px)`;

    }

  });

});






document.addEventListener("DOMContentLoaded", function () {

  const elements = document.querySelectorAll(
    "#shopify-section-template--21733953274112__section_mPDfE6, \
     #shopify-section-template--21733953274112__section_irzJ8G, \
     #shopify-section-template--21733953274112__section_x4x4RP"
  );

  window.addEventListener("scroll", function () {

    elements.forEach(el => {

      const rect = el.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      if (rect.top < windowHeight && rect.bottom > 0) {

        let progress = (windowHeight - rect.top) / windowHeight;
        progress = Math.min(Math.max(progress, 0), 1);

        let scale = 1 - progress * 0.2; 
        let opacity = 1 - progress * 0.1;

        el.style.transform = "scale(" + scale + ")";
        el.style.opacity = opacity;

      }

    });

  });

});


document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname === '/products/madorah-gift-card') {
    
    // Hide button
    var btn = document.getElementById('sizeChartBtn');
    if (btn) btn.style.display = 'none';

    // Hide accordions
    var acc1 = document.querySelector('.accordion--AWTh2Q3Bzb2FFUFhkc__accordion_g8EVVp');
    var acc2 = document.querySelector('.accordion--plu');

    if (acc1) acc1.style.display = 'none';
    if (acc2) acc2.style.display = 'none';
  }
});



// header scroll
// document.addEventListener("DOMContentLoaded", function () {

//     const header = document.querySelector("#header-component");

//     function onScroll() {
//         if (window.scrollY > 20) {
//             header.style.setProperty("--color-scheme-top-row", "rgba(255,255,255,1)");
//             header.querySelector(".header__underlay-closed").style.background = "#fff";
//         } else {
//             header.style.setProperty("--color-scheme-top-row", "rgba(0,0,0,0)");
//             header.querySelector(".header__underlay-closed").style.background = "transparent";
//         }
//     }

//     onScroll();
//     window.addEventListener("scroll", onScroll);

// });


// document.addEventListener("DOMContentLoaded", function () {
//     const header = document.querySelector("#header-component");

//     function handleScroll() {
//         if (window.scrollY > 20) {
//             header.classList.add("scrolled");
//         } else {
//             header.classList.remove("scrolled");
//         }
//     }

//     handleScroll();
//     window.addEventListener("scroll", handleScroll);
// });